import axios from 'axios';
import store from "@/store";

export default {
  
  async getActiveWindow(type, id) {
    try {
      return await axios.get(`/rest/v4/session/storage/active-windows/${type}/${id}`);
    } catch (error) {
      return undefined;
    }
  },

  async postActiveWindow(type, id, data) {
    await axios.post(`/rest/v4/session/storage/active-windows`, {type: type, id: id, data: data});
  },

  async deleteActiveWindow(type, id) {
    await axios.delete(`/rest/v4/session/storage/active-windows/${type}/${id}`);
  },

  async deleteActiveWindows(data) {
    await axios.post('/rest/v4/session/storage/active-windows/remove', data);
  },


  async getActiveWindows(data) {
    let response =  await axios.post('/rest/v4/session/storage/active-windows/query', data);
    return response.data;
  },

  async getAllActiveWindows() {
    let response = await axios.get(`/rest/v4/session/storage/active-windows`);
    return response.data;
  },

  async getRoutingHistoryOfAllWindows() {
    let response = await axios.get(`/rest/v4/session/storage/active-windows/routing-history`);
    return response?.data ?? [];
  },

  async updateActiveWindowCount() {
    let response = await axios.get(`/rest/v4/session/storage/active-windows/count`);
    store.commit('badgeCounter/setActiveWindowsCount', response?.data ?? 0);
  },
}